/*@flow*/
import type { Node, Element } from "react";
import React from "react";
import ResourceFormOpener from "comps/ResourceBuilder/ResourceForm/Link";
import * as I from "immutable";
import useCachedQuery from "lib/useCachedQuery";
import NonEmptyArray from "lib/NonEmptyArray";
import gql from "graphql-tag";
import type { DocumentNode } from "graphql";
import cx from "classnames";

const GET_UNIT = (gql(`
  query getUnit($unitId: ID!) {
    me {
      id
      company {
        id
        unit(id: $unitId) {
          theGeom
        }
      }
    }
  }
`): DocumentNode);

type Props = {
  unitId: ID,
  title: string,
  className: string,
};

export default (props: Props): Node | Element<"span"> => {
  const { data, loading, errors } = useCachedQuery(GET_UNIT, {
    variables: { unitId: props.unitId },
  });
  const theGeom = I.getIn(data, ["me", "company", "unit", "theGeom"]);
  if (NonEmptyArray.is(errors)) {
    return <span>{errors.map((v) => v.error)}</span>;
  }

  return (
    <ResourceFormOpener
      id={null}
      className={props.className}
      resourceName="Tenant"
      title={props.title}
      resource={{
        unitIds: [props.unitId],
        theGeom,
        status: "Open",
      }}
    >
      <i
        className={cx("fa", {
          "fa-plus": !loading,
          "fa-spinner fa-spin": loading,
        })}
      />{" "}
      Create Tenant
    </ResourceFormOpener>
  );
};
